export enum RequestType {
  Meeting = 'meeting',
  OnlineAdvice = 'online_advice',
  TopUpInvestment = 'top_up_investment',
}
